import { occupancyDuration } from '../lib/format'
import { useI18n } from '../i18n/useI18n'

/**
 * Duree d'occupation d'une unite par son locataire, en clair.
 *
 * Le francais accorde « an » au pluriel et pas « mois » : on choisit
 * donc une cle de traduction par cas plutot que d'ajouter un « s » au
 * hasard, ce qui donnerait « 1 ans ».
 *
 * Si la date de debut est inconnue, on l'ecrit. Afficher zero serait
 * un mensonge.
 */
export function Occupancy({
  startDate,
  endDate,
}: {
  startDate: string | null
  endDate: string | null
}) {
  const { t } = useI18n()
  const d = occupancyDuration(startDate, endDate)

  if (d === null) {
    return <span className="list__note">{t('occupancy_unknown')}</span>
  }

  const { years: n, months: m } = d

  let texte: string
  if (n === 0 && m === 0) texte = t('occupancy_new')
  else if (n === 0 && m === 1) texte = t('occupancy_1_month')
  else if (n === 0) texte = t('occupancy_months', { m })
  else if (n === 1 && m === 0) texte = t('occupancy_1_year')
  else if (n === 1) texte = t('occupancy_1_year_months', { m })
  else if (m === 0) texte = t('occupancy_years', { n })
  else texte = t('occupancy_years_months', { n, m })

  return <span className="list__note">{texte}</span>
}
